import { cn } from "~/lib/utils";
import { quantityInputControlStyles } from "~/components/Inputs/quantity-input-control/quantity-input-control";

import { AddButton } from "./add-button";

type CountPillProps = {
  value: number;
  onClick: () => void;
  className?: string;
};

export const CountPill = ({ value, onClick, className }: CountPillProps) => {
  if (value === 0) {
    return <AddButton onClick={onClick} className={className} />;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        quantityInputControlStyles({ variant: "primary" }),
        "h-16 w-auto min-w-16 px-4",
        className
      )}
    >
      {value}
    </button>
  );
};
